// Counts on the post actions: short for large numbers (1.2K, 1,5 Mio.),
// in the user's language, so they fit beside the icons on a phone.
const formats = new Map()

export const compactCount = (count, locale) => {
  if (!formats.has(locale)) {
    formats.set(
      locale,
      new Intl.NumberFormat(locale, {
        notation: 'compact',
        maximumFractionDigits: 1,
      }),
    )
  }
  return formats.get(locale).format(count)
}
